import { include } from 'underscore.string';
import { Listener, ILogMessage } from '@bingads-webui/listener';
import { IConsoleListenerOptions } from '../types';

/**
 * Console listener class
 */
export class ConsoleListener extends Listener {
  constructor(options: IConsoleListenerOptions = {}) {
    super();

    this.formatters = options.formatters || [];
    this.filters = options.filters || [];
  }

  init() {
    this.initialized = true;
  }

  /* eslint-disable no-console */
  write(logMessage: ILogMessage) {
    if (!this.initialized || this.filterLogs(logMessage)) {
      return;
    }

    const formattedMsg = this.formatLogs(logMessage);

    const category = logMessage.logCategory || '';
    if (include(category.toLowerCase(), 'error')) {
      console.error(formattedMsg);
    } else {
      console.log(formattedMsg);
    }

    // TODO: use console.timeStamp for activity perf marker
  }
}
